import { render } from "./Prompt_message.vue?vue&type=template&id=51c210e2&scoped=true"
import script from "./Prompt_message.vue?vue&type=script&lang=js"
export * from "./Prompt_message.vue?vue&type=script&lang=js"

import "./Prompt_message.vue?vue&type=style&index=0&id=51c210e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c210e2"]])

export default __exports__